// @ts-ignore
import("./bootstrap");

export {};
